const menus = [
    {
        id: 1,
        name: 'Home',
        links: '/',  
    },
    {
        id: 2,
        name: 'DT Shop',
        links: '/dt-shop',
    },
    {
        id: 4,
        name: 'More',
        links: '#',
        namesub: [
            {
                id: 1,
                sub: 'My Vault',
                links: '/dashboard'
            },
            {
                id: 2,
                sub: 'Help Center',
                links: '/help-center'
            },
            {
                id: 4,
                sub: 'FAQ',
                links: '/faqs'
            },
            {
                id: 5,
                sub: 'Policies',
                links: '/Policies'
            },
            {
                id: 6,
                sub: 'Login',
                links: '/login'
            },
            {
                id: 7,
                sub: 'Sign Up',
                links: '/signup'
            },
        ],
    },
    {
        id: 5,
        name: 'About Us',
        links: '/about-us',
    },
    {
        id: 6,
        name: 'Blog',
        links: '/blog',
    },

    {
        id: 7,
        name: 'Support',
        links: '/contact',
    },
    
]

export default menus;